import { useState } from "react";
import { Box, Stack, Typography } from "@mui/material";

import BreakdownChartCard from "../../../../../components/Dashboard/BreakdownChartCard";
import DashboardSummaryStrip from "../../../../../components/Dashboard/DashboardSummaryStrip";
import TimeSeriesCard from "../../../../../components/Dashboard/TimeSeriesCard";
import { formatMoney, formatNumber } from "../../../../../libs/dashboardOverview";

const OverviewSection = ({ overview }) => {
  const [timeframe, setTimeframe] = useState(6);

  return (
    <Stack spacing={2}>
      <Stack spacing={0.5}>
        <Typography variant="h5" sx={{ fontWeight: 800 }}>
          Overview
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Spend, engagement pipeline, and billing health.
        </Typography>
      </Stack>
      <DashboardSummaryStrip items={overview?.summary || []} />
      <TimeSeriesCard
        title="Spend over time"
        subtitle="Recorded payment volume by month"
        data={overview?.seriesByRange?.[timeframe] || overview?.series || []}
        formatter={formatMoney}
        timeframe={timeframe}
        onTimeframeChange={setTimeframe}
      />
      <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", md: "repeat(3, minmax(0, 1fr))" } }}>
        <Box>
          <BreakdownChartCard title="Engagement status" subtitle="Contracts by pipeline state" data={overview?.breakdowns?.engagements || []} formatter={formatNumber} color="#1a73e8" />
        </Box>
        <Box>
          <BreakdownChartCard title="Billing status" subtitle="Paid, due, and overdue amounts" data={overview?.breakdowns?.billing || []} formatter={formatMoney} color="#05690D" />
        </Box>
        <Box>
          <BreakdownChartCard title="Spend by service" subtitle="Budget by requested role" data={overview?.breakdowns?.serviceSpend || []} formatter={formatMoney} color="#f9ab00" />
        </Box>
      </Box>
    </Stack>
  );
};

export default OverviewSection;
